import React, { useContext } from "react";
import { UiContext, UiContextProps } from "../contexts";
import centerArrow from "../assets/icons/arrow-down-center.png";
import leftArrow from "../assets/icons/arrow-down-left.png";
import rightArrow from "../assets/icons/arrow-down-right.png";

/**Parameters expected by the Popover component.
 * @param {string} content - The text to be displayed by the popover.
 * @param {string} arrowPosition - Determines the location of the arrow beneath the content, if it exists. Should be "right", "left" or "none".
 * @param {string | undefined} marginOrientation - An optional parameter that adjusts the location of the popover. Passed into the component's "style" attribute.
*/
interface PopoverProps {
    content: string
    arrowPosition: string
    marginOrientation?: string
    onPopoverClicked: () => void
}

/**A small component that displays a small box of informational text.
 * @param {PopoverProps} props - Parameters expected by the GamePage.
 */
export const Popover = (props: PopoverProps) => {
    const {content, arrowPosition, marginOrientation, onPopoverClicked } = props;
    const { isExpanded } = useContext(UiContext) as UiContextProps;
    const currentMargin = marginOrientation? marginOrientation : "auto auto auto auto";

    const setArrowPosition = () => {
        const arrowIcon = arrowPosition === "right" ? <img src={rightArrow} alt="Right arrow"/> : <img src={leftArrow} alt="Left arrow"/>;

        switch(arrowPosition) {
            case "right":
            case "left":
                return(<div style={{textAlign: arrowPosition}}>{arrowIcon}</div>);
            case "none":
                return;
            default:
                return(<div style={{textAlign: "center"}}><img src={centerArrow} alt="Center arrow"/></div>);
        }
    }

    return (
        <div className={`popover${isExpanded ? "-expanded" : ""}`} style={{margin: currentMargin}} onClick={onPopoverClicked}>
            <div className="popover-content">
                <p>{content}</p>
            </div>
            <div className="popover-arrow">
                {setArrowPosition()}
            </div>
        </div>
    );
}